import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BusinessConsulting from './pages/BusinessConsulting';
import FinancialPlanning from './pages/FinancialPlanning';
import ProjectManagement from './pages/ProjectManagement';
import PartnershipDevelopment from './pages/PartnershipDevelopment';
import MarketAnalysis from './pages/MarketAnalysis';
import OperationalExcellence from './pages/OperationalExcellence';

function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Contact />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services/business-consulting" element={<BusinessConsulting />} />
          <Route path="/services/financial-planning" element={<FinancialPlanning />} />
          <Route path="/services/project-management" element={<ProjectManagement />} />
          <Route path="/services/partnership-development" element={<PartnershipDevelopment />} />
          <Route path="/services/market-analysis" element={<MarketAnalysis />} />
          <Route path="/services/operational-excellence" element={<OperationalExcellence />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

